export default function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}


//////////////////
// WEBPACK FOOTER
// /Users/ulrich/Sites/PRNSA/site/web/app/themes/prnsa-theme/node_modules/swiper/esm/components/core/transition/setTransition.js
// module id = 76
// module chunks = 0